export function getImage(path) {
  const baseUrl = global.BASE_URL || process.env.VUE_APP_BASE_URL;

  if (baseUrl) {
    return `${baseUrl}${path}`;
  }

  return null;
}
